import { graphql } from '~/gql'

export const GET_SIGNED_CONVERTED_URL = graphql(`
  query GetSignedConvertedURL($url: String!, $filename: String!) {
    url: getSignedConvertedURL(url: $url, filename: $filename) {
      url
    }
  }
`)
